import type { Paragraph, Table } from 'docx';
import type { NodeEntry } from 'slate';

import type { DocumentContext } from './internal';
import { createDocxAlineContentBlock } from './internal';
import type { DynamicBlockElement } from '../../../slate-api';
import { Queries } from '../../../slate-api';

export function createDynamicBlockChildren(
  dynamicBlockEntry: NodeEntry<DynamicBlockElement>,
  options: { context: DocumentContext }
): (Paragraph | Table)[] {
  const [dynamicBlock, dynamicBlockPath] = dynamicBlockEntry;
  const isEmpty = Queries.nodeIsEmpty(dynamicBlock);
  // Empty DCs are not rendered in Aline docs.
  if (isEmpty) return [];

  return dynamicBlock.children.flatMap((child, index) =>
    createDocxAlineContentBlock([child, dynamicBlockPath.concat(index)], options)
  );
}
